import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import CloseIcon from "src/components/ui/svgIcon/CloseIcon";
import SearchIcon from "src/components/ui/svgIcon/SearchIcon";
import PrimaryHoverEffect from "src/components/ui/warehouse/primaryHoverEffect";
import { SearchMenuBox } from "../professionalSection/style";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import TrackingTracingSection from "./product-tracking/TrackingTracingSection";

const options = [
  { id: 1, label: "ردگیری وردیابی محصولات" },
  // { id: 2, label: "آزمایشگاه" },
  // { id: 3, label: "خوراک" },
];

const TraceabilitySection = (menu) => {
  let Icon;
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const id = open ? "simple-popover" : undefined;
  const DEFAULT_FRUIT_ID = 1;

  const [selectedId, setSelectedId] = useState(DEFAULT_FRUIT_ID);

  const handleChange = (event) => {
    setSelectedId(event.target.value);
  };

  const selectedItem = options.find((item) => item?.id === selectedId);

  if (menu?.menu?.length !== 0)
    return (
      <Box>
        <Box sx={{ textAlign: "center" }}>
          <PrimaryHoverEffect className={open ? "active" : ""}>
            <IconButton sx={{ px: 0 }} aria-describedby={id} onClick={handleClick}>
              <SearchIcon fontSize="small" color={theme.palette.text.primary} />
            </IconButton>
          </PrimaryHoverEffect>

          <SearchMenuBox
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Stack textAlign="center" justifyContent="center" direction="row">
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon color={theme.palette.grey.g3} />
              </IconButton>
              <Typography variant="subtitle1" fontWeight="bold">
                {menu?.menu[0]?.node?.menuName}
              </Typography>
            </Stack>
            <>
              <Stack mt={3}>
                <FormControl fullWidth>
                  <InputLabel id="kind-label" sx={{ fontSize: "1.3rem" }}>
                    نوع
                  </InputLabel>
                  <Select labelId="kind-label" value={selectedId} label="kind-label" onChange={handleChange}>
                    {options.map((option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
            </>
            {selectedItem?.id === 1 && <TrackingTracingSection menu={menu} />}
          </SearchMenuBox>
        </Box>
      </Box>
    );
};

export default TraceabilitySection;
